export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL || 'https://7nom9v7zgk.execute-api.us-east-2.amazonaws.com';

export const API_ENDPOINTS: Record<string, string> = {
  GENERATE: `${API_BASE_URL}/jobs/generate`,
  STATUS: `${API_BASE_URL}/jobs`,
  DOWNLOAD: `${API_BASE_URL}/files`,
  REVISE: `${API_BASE_URL}/jobs/revise`,
  MERGE_SECTIONS: `${API_BASE_URL}/jobs/merge-sections`,
  LIST_JOBS: `${API_BASE_URL}/jobs`,
  JOB_FAMILY: `${API_BASE_URL}/jobs`,
};

export const POLLING_INTERVAL: number = 6000;
export const MAX_POLLING_ATTEMPTS: number = 150;

export const MAX_FILE_SIZE: number = 10 * 1024 * 1024;
export const ALLOWED_FILE_TYPES: string[] = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'text/markdown',
  'text/x-markdown',
];

export const FILE_TYPE_EXTENSIONS: Record<string, string> = {
  'application/pdf': '.pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
  'text/plain': '.txt',
  'text/markdown': '.md',
  'text/x-markdown': '.markdown',
};

export const JOB_STATUSES: Record<string, string> = {
  IDLE: 'idle',
  UPLOADING: 'uploading',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const ERROR_MESSAGES: Record<string, string> = {
  FILE_TOO_LARGE: `File size must be less than ${MAX_FILE_SIZE / 1024 / 1024}MB`,
  INVALID_FILE_TYPE: 'Only PDF, DOCX, TXT, and Markdown files are supported',
  UPLOAD_FAILED: 'Failed to upload file. Please try again.',
  GENERATION_FAILED: 'Failed to generate case study. Please try again.',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  TIMEOUT_ERROR: 'Request timed out. Please try again.',
};

export const SUCCESS_MESSAGES: Record<string, string> = {
  UPLOAD_SUCCESS: 'File uploaded successfully!',
  GENERATION_SUCCESS: 'Case study generated successfully!',
  FEEDBACK_SUBMITTED: 'Thank you for your feedback!',
};

export const DEFAULT_GENERATION_OPTIONS: Record<string, string | boolean> = {
  length: 'medium',
  style: 'professional',
  includeCharts: true,
  includeSummary: true,
};

export const FEATURES: Record<string, boolean> = {
  FEEDBACK_ENABLED: import.meta.env.VITE_FEEDBACK_ENABLED !== 'false',
  ANALYTICS_ENABLED: import.meta.env.VITE_ANALYTICS_ENABLED === 'true',
  DEBUG_MODE: import.meta.env.DEV,
};

export const FEEDBACK_CATEGORIES: Record<string, string> = {
  CLARITY: 'clarity',
  ACCURACY: 'accuracy',
  COMPLETENESS: 'completeness',
  TONE: 'tone',
  STRUCTURE: 'structure',
  TECHNICAL_DEPTH: 'technical_depth',
  BUSINESS_VALUE: 'business_value',
  FORMATTING: 'formatting',
  OTHER: 'other',
};
